module.exports = __webpack_public_path__ + "static/news (1)-1cd6724125aab1fe1ec576b8960a3fd8.jpg";